import React, { useState } from 'react';
import {
	Dropzone,
	DropzoneStatus,
	MS_EXCEL_MIME_TYPE
} from '@mantine/dropzone';
import { getIconColor } from '../../../../../Utils/upload/uploadImagesUtils';

import { Group, Text, MantineTheme, useMantineTheme } from '@mantine/core';
import { Upload, File, X, Icon as TablerIcon } from 'tabler-icons-react';
import validator from 'validator';
import { EmailTag } from '../emailTag';
import readXlsxFile, { Row } from 'read-excel-file';

export function StandaloneUsersModal({
	setModalOpen,
	emailAdrs,
	setEmailAdrs
}: {
	setModalOpen: (isOpen: boolean) => void;
	emailAdrs: string[];
	setEmailAdrs: (emailAdrs: string[]) => void;
}) {
	const [emailAdrText, setEmailAdrText] = useState('');
	const [file, setFile] = useState<File[]>();
	const [emailErrorMsg, setemailErrorMsg] = useState({
		message: '',
		error: false
	});

	const theme = useMantineTheme();

	const readFile = async (file: File[]) => {
		console.log('file', file);
		setFile(file);

		readXlsxFile(file[0]).then((rows: Row[]) => {
			const updatedEmailAdrs = emailAdrs.slice();
			rows.forEach((row: Row) => {
				console.log('row', row);
				const cells = Array.from(JSON.parse(JSON.stringify(row)));
				cells.forEach((cell: any) => {
					console.log('cell', cell);
					if (!verifEmailFormat(cell)) {
						updatedEmailAdrs.push(cell);
					}
				});
			});
			setEmailAdrs(updatedEmailAdrs);
		});
	};

	const verifEmailFormat = (email = '') => {
		if (validator.isEmpty(email, { ignore_whitespace: true })) {
			setemailErrorMsg({
				error: true,
				message: 'Please enter your email address'
			});
			return true;
		} else {
			if (!validator.isEmail(email)) {
				setemailErrorMsg({
					error: true,
					message: 'Email must be a valid format'
				});
				return true;
			} else if (email.indexOf(' ') >= 0) {
				setemailErrorMsg({
					error: true,
					message: 'Email must not contain white spaces'
				});
				return true;
			} else {
				setemailErrorMsg({ error: false, message: '' });
				return false;
			}
		}
	};

	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
						w-4/6 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
		>
			<div
				className="relative bg-gray-300 w-full max-h-screen overflow-y-auto
									dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
			>
				<div className="flex flex-col justify-center px-4 py-2">
					<h3 className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xl font-bold mb-2 px-3 self-center">
						Selected non meavana Email Addresses to be contacted
					</h3>

					<h3 className="mt-3 text-gray-700 dark:text-gray-300 text-md font-bold mb-2 px-3">
						{`Selected users: ${emailAdrs.length}`}
					</h3>
					<div>
						<div className="overflow-x-auto ">
							<div className="mx-auto w-full px-3 mb-1 z-0">
								<Dropzone
									className="dark:bg-gray-800 z-0 transition-all duration-500"
									onDrop={(file) => {
										readFile(file);
									}}
									onReject={(files) => console.log('rejected files', files)}
									maxSize={30 * 1024 ** 2}
									accept={MS_EXCEL_MIME_TYPE}
								>
									{(status) => dropzoneChildren(status, theme, file)}
								</Dropzone>
							</div>
							<h3 className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xl font-bold mb-2 px-3 self-center">
								Or
							</h3>

							<div className=" flex flex-row w-full mt-2 pr-1.5 mb-2 px-3 ">
								<div className="w-full h-auto">
									<input
										className="inputStyle py-2"
										id="grid-last-name"
										type="text"
										placeholder="address@email.com"
										onChange={(e) => {
											if (!emailErrorMsg.error) setEmailAdrText(e.target.value);
										}}
										onBlur={(e) => {
											verifEmailFormat(e.target.value);
										}}
										onFocus={() => {
											setemailErrorMsg({ error: false, message: '' });
										}}
										value={emailAdrText}
									/>
									{emailErrorMsg.error ? (
										<p className="text-red-500 text-xs italic text-right ml-auto h-4">
											{emailErrorMsg.message}
										</p>
									) : (
										<div className="mb-4" />
									)}
								</div>
								<button
									type="button"
									className="btn btn-outline btn-sm btn-primary mr-2 ml-3 mt-1"
									onClick={() => {
										if (!verifEmailFormat(emailAdrText)) {
											const updatedEmailAdrs: string[] =
												emailAdrs.concat(emailAdrText);
											setEmailAdrs(updatedEmailAdrs);
											setEmailAdrText('');
										}
									}}
								>
									Add Email address
								</button>
							</div>
						</div>
					</div>

					<div className="flex flex-wrap space-x-2">
						{emailAdrs.map((adr, index) => (
							<div className="mb-2">
								<EmailTag
									key={adr}
									adr={adr}
									index={index}
									setEmailAdrs={setEmailAdrs}
									allAdrs={emailAdrs}
								/>
							</div>
						))}
					</div>
				</div>
			</div>

			<div
				className="flex flex-row justify-end pt-3 pb-2 px-6 space-x-2 -mt-1
						bg-gray-300 dark:bg-gray-900 shadow-lg transition-colors duration-300 rounded-b-xl"
			>
				<button
					data-modal-toggle="defaultModal"
					className="btn btn-outline btn-primary btn-sm mr-1 "
					type="button"
					style={{ transition: 'all .15s ease' }}
					onClick={() => {
						setModalOpen(false);
					}}
				>
					Done
				</button>
			</div>
		</div>
	);
}

function ImageUploadIcon({
	status,
	...props
}: React.ComponentProps<TablerIcon> & { status: DropzoneStatus }) {
	if (status.accepted) {
		return <Upload {...props} />;
	}

	if (status.rejected) {
		return <X {...props} />;
	}

	return <File {...props} />;
}

const dropzoneChildren = (
	status: DropzoneStatus,
	theme: MantineTheme,
	file: File[] | undefined
) => (
	<Group position="center" style={{ minHeight: 80 }}>
		{file != null ? (
			<>
				<ImageUploadIcon
					status={status}
					style={{ color: getIconColor(status, theme) }}
					size={80}
				/>
				<div className="text-center">
					<Text size="xl" inline className="dark:text-gray-500">
						{file[0].name}
					</Text>
				</div>
			</>
		) : (
			<>
				<ImageUploadIcon
					status={status}
					style={{ color: getIconColor(status, theme) }}
					size={80}
				/>
				<div className="text-center">
					<Text size="xl" inline className="dark:text-gray-500">
						Drag a file here or click to select a file
					</Text>
				</div>
			</>
		)}
	</Group>
);
